import React from 'react';
import { Menu } from '@headlessui/react';
import { ChevronDown, Check } from 'lucide-react';
import { clsx } from 'clsx';

export interface FilterChipOption {
  id: string;
  label: string;
}

interface FilterChipProps {
  label: string;
  options: FilterChipOption[];
  selected: string;
  onSelect: (id: string) => void;
}

/** Compact dropdown used for the in-page filter row. */
const FilterChip: React.FC<FilterChipProps> = ({ label, options, selected, onSelect }) => (
  <Menu as="div" className="relative">
    <Menu.Button className="inline-flex items-center gap-1.5 rounded-[10px] border border-border bg-muted px-3 py-1.5 text-[12.5px] text-foreground hover:bg-accent">
      {label} <ChevronDown className="w-3.5 h-3.5" />
    </Menu.Button>
    <Menu.Items className="absolute left-0 top-9 z-20 min-w-[180px] bg-card border border-border rounded-[10px] shadow-lg p-1 focus:outline-none">
      {options.map((o) => (
        <Menu.Item key={o.id}>
          {({ active }) => (
            <button
              onClick={() => onSelect(o.id)}
              className={clsx(
                'flex items-center gap-2 w-full px-2.5 py-1.5 rounded-md text-[13px] text-left',
                active && 'bg-muted',
                o.id === selected ? 'text-primary font-medium' : 'text-foreground',
              )}
            >
              <span className="flex-1 truncate">{o.label}</span>
              {o.id === selected && <Check className="w-3.5 h-3.5" />}
            </button>
          )}
        </Menu.Item>
      ))}
    </Menu.Items>
  </Menu>
);

export default FilterChip;
